import React, { useState, useEffect } from 'react';
import {
  Calendar,
  Clock,
  Users,
  Award,
  Target,
  BookOpen,
  Globe,
  CheckCircle,
  ArrowRight,
  FileText,
  Mail,
  AlertCircle,
  Send,
  Video,
  Download,
  MessageSquare,
  Bell,
  Upload,
  ExternalLink,
  Sparkles,
  TrendingUp,
  Heart,
  Shield,
  Loader2
} from 'lucide-react';

const ProyectoUNITWIN = () => {
  const [unitwinData, setUnitwinData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
  const response = await fetch(`/data/unitwin.json?v=${Date.now()}`);
        const data = await response.json();
        setUnitwinData(data);
      } catch (error) {
        console.error('Error al cargar datos de UNITWIN:', error);
      } finally {
        setIsLoadingData(false);
      }
    };

    cargarDatos();
  }, []);

  const getIconComponent = (iconName) => {
    const icons = {
      Bell, Upload, FileText, Calendar, Award
    };
    return icons[iconName] || Calendar;
  };

  const productos = [
    {
      titulo: 'Divulgación',
      descripcion: 'La divulgación de los trabajos enviados por los representantes de Cátedras UNESCO será a través de medios electrónicos.',
      icono: Globe,
      color: 'blue'
    },
    {
      titulo: 'Publicación',
      descripcion: 'Las publicaciones generadas por cada representante de cátedra se publicarán en revistas indexadas.',
      icono: BookOpen,
      color: 'green'
    }
  ];

  const criteriosTecnicos = [
    'Utilizar el sistema de referencias de la APA 7ª. Ed. Así como los criterios editoriales para la presentación de tablas, gráficos, diagramas, imágenes.',
    'Los trabajos se identificarán con el nombre o nombres del autor/a o autores que aparecerán después del título, y centrados. A pie de página se señalarán los datos de identificación académica, ORCID, institución de procedencia, correo electrónico institucional de enlace',
    'El documento se enviará en formato Word, hojas tamaño carta, con márgenes superior e inferior de 2.5 centímetros e izquierdo y derecho de 3 cm.',
    'Resumen en la lengua de origen e inglés',
    'Adjuntar carta de originalidad del trabajo en formato libre'
  ];

  const causalesNoAceptacion = [
    'No cumplir con el formato solicitado',
    'No presentar un trabajo original, y/o carente de calidad en contenido, formato y pertinencia',
    'No adjuntar la carta de responsabilidad de la originalidad'
  ];

  const colorClasses = {
    blue: 'border-blue-500 bg-blue-50',
    green: 'border-[#0b742f] bg-green-50',
    orange: 'border-[#e87729] bg-orange-50',
    purple: 'border-purple-500 bg-purple-50',
    red: 'border-red-500 bg-red-50',
    yellow: 'border-yellow-500 bg-yellow-50'
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
              <Globe className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Segundo encuentro Iberoamericano de Cátedras UNESCO
              </h1>
              <p className="text-xl md:text-2xl text-white/90 font-semibold mb-2">
                Proyecto Red UNITWIN CONOCIMIENTO EN MARCHA
              </p>
              <p className="text-lg md:text-xl text-white/80 mb-6">
                Redes y grupos de investigación
              </p>
              <div className="flex flex-wrap items-center gap-4 text-sm md:text-base">
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                  <Calendar className="w-5 h-5" />
                  {isLoadingData ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <span>{unitwinData?.evento?.fechasEvento || '25 y 26 de marzo de 2026'}</span>
                  )}
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                  <Video className="w-5 h-5" />
                  <span>{unitwinData?.evento?.modalidad || 'Modalidad Virtual'}</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
                  <Award className="w-5 h-5" />
                  <span>Evento Gratuito</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* Logos de organizadores */}
        <section className="mb-12">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 shadow-xl border border-gray-200 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-[#0077C8]/5 via-transparent to-[#0b742f]/5"></div>
            <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 md:gap-10">
              {/* Logo Cátedra UNESCO */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0077C8]/20">
                  <img
                    src="https://recursos.cenid.org/img_cenid/catedra_sin_fondo_letra_azul.png"
                    alt="Cátedra UNESCO"
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-600 group-hover:text-[#0077C8] transition-colors text-center">Cátedra UNESCO</span>
              </div>

              {/* Separator 1 */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-[#0077C8] to-transparent"></div>
                  <div className="bg-[#e87729] p-2 rounded-full shadow-lg">
                    <Users className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-[#e87729] via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-[#0077C8] to-transparent"></div>
              </div>

              {/* Logo UAEMéx */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#e87729]/20">
                  <img
                    src="https://recursos.cenid.org/img_cenid/uaemex.png"
                    alt="UAEMéx"
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-600 group-hover:text-[#e87729] transition-colors text-center">UAEMéx</span>
              </div>

              {/* Separator 2 */}
              <div className="flex items-center justify-center">
                <div className="hidden md:flex flex-col items-center gap-2">
                  <div className="w-px h-12 bg-gradient-to-b from-transparent via-[#e87729] to-transparent"></div>
                  <div className="bg-[#0b742f] p-2 rounded-full shadow-lg">
                    <BookOpen className="w-5 h-5 text-white" />
                  </div>
                  <div className="w-px h-12 bg-gradient-to-b from-[#0b742f] via-transparent to-transparent"></div>
                </div>
                <div className="md:hidden w-32 h-px bg-gradient-to-r from-transparent via-[#e87729] to-transparent"></div>
              </div>

              {/* Logo CENID */}
              <div className="group flex flex-col items-center">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 border-2 border-transparent hover:border-[#0b742f]/20">
                  <img
                    src="https://recursos.cenid.org/img_cenid/cenid.png"
                    alt="CENID"
                    className="h-24 md:h-32 w-auto object-contain"
                  />
                </div>
                <span className="mt-3 text-sm font-semibold text-gray-600 group-hover:text-[#0b742f] transition-colors text-center">CENID</span>
              </div>
            </div>
          </div>
        </section>

        {/* Organizadores */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-lg p-8 border-l-4 border-[#0b742f]">
            <div className="mb-6">
              <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                <Users className="w-8 h-8 text-[#0b742f]" />
                Organizadores
              </h2>
              <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
            </div>

            <div className="space-y-4">
              <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Cátedra UNESCO Vulnerabilidad e Inclusión Social
                </h3>
                <p className="text-gray-700">Universidad Autónoma del Estado de México</p>
              </div>

              <div className="bg-orange-50 border-l-4 border-[#e87729] p-6 rounded-r-lg">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Centro de Estudios e Investigaciones para el Desarrollo Docente
                </h3>
                <p className="text-gray-700">CENID, A.C.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Convocatoria */}
        <section className="mb-12">
          <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white rounded-lg shadow-xl p-8">
            <h2 className="text-3xl font-bold mb-4 flex items-center gap-3">
              <Bell className="w-8 h-8" />
              Convocatoria a representantes de Cátedras UNESCO
            </h2>
            <p className="text-lg text-white/90 leading-relaxed">
              A Cátedras UNESCO en Iberoamérica a participar en el Segundo Encuentro Iberoamericano de Cátedras UNESCO a realizarse del{' '}
              {isLoadingData ? (
                <Loader2 className="inline w-4 h-4 animate-spin" />
              ) : (
                <strong>{unitwinData?.evento?.fechasEvento || '25 y 26 de marzo de 2026'}</strong>
              )}
              , para divulgar los trabajos y discusiones actuales en la agenda de cada Cátedra, cuyo objetivo es movilizar la inteligencia colectiva a través la popularización democrática del conocimiento, con base en la experiencia e impacto sobre la Agenda 2030 de los ODS que cada una tiene y así contribuir, en el marco de la región, la capacidad de acción orientada hacia la inclusión, igualdad, integración y complementariedad sobre iniciativas ciudadanas.
            </p>
          </div>
        </section>

        {/* Agenda 2030 */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Target className="w-8 h-8 text-[#e87729]" />
                  Agenda 2030 y ODS
                </h2>
                <div className="h-1 w-32 bg-[#0b742f] rounded-full"></div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-6 text-justify">
                La Agenda 2030 para el Desarrollo Sostenible es un compromiso intergubernamental y un plan de acción a favor de las personas, el planeta y la prosperidad. Incluye 17 Objetivos de Desarrollo Sostenible (ODS) que son de carácter integrado e indivisible y conjugan las tres dimensiones del desarrollo sostenible: económica, social y ambiental; y reflejan la dimensión de la nueva Agenda universal.
              </p>

              <div className="bg-orange-50 border-l-4 border-[#e87729] p-6 rounded-r-lg">
                <p className="text-gray-700 leading-relaxed">
                  <strong>Meta:</strong> Ampliar los límites del conocimiento sobre temas relacionados con el mandato de la UNESCO en educación, cultura, comunicación y ciencias, así como cuestiones más amplias para las Naciones Unidas materia de los ODS.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Objetivo General */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md p-8 border-l-4 border-[#0b742f]">
            <div className="mb-4">
              <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                <Target className="w-8 h-8 text-[#0b742f]" />
                Objetivo general
              </h2>
              <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
            </div>
            <p className="text-gray-700 leading-relaxed text-justify">
              Establecer debates y propuestas que activen procesos psicosociales de capacidad de agencia individual y colectiva en la ciudadanía, en el sector público, en organizaciones civiles y sector privado de cara a problemas comunitarios que afectan su sostenibilidad.
            </p>
          </div>
        </section>

        {/* Sede e Información */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-[#0b742f] hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-[#0b742f]/10 p-3 rounded-lg">
                <Globe className="w-6 h-6 text-[#0b742f]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Sede</h3>
            </div>
            <p className="text-gray-600">Centro de Estudios e Investigaciones para el Desarrollo Docente A C (CENID)</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-[#e87729] hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-[#e87729]/10 p-3 rounded-lg">
                <Video className="w-6 h-6 text-[#e87729]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Modalidad</h3>
            </div>
            <p className="text-gray-600">Virtual, transmitida a través de redes sociales y canal de YouTube</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-blue-500 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-blue-500/10 p-3 rounded-lg">
                <Award className="w-6 h-6 text-blue-500" />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Costo</h3>
            </div>
            <p className="text-gray-600 font-bold text-xl">Evento totalmente gratuito</p>
          </div>
        </div>

        {/* Procesos de Inscripción */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <CheckCircle className="w-8 h-8 text-[#0b742f]" />
                  Procesos de inscripción
                </h2>
                <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
              </div>

              <div className="space-y-4 mb-6">
                {unitwinData?.procesosInscripcion?.map((proceso, index) => (
                  <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg hover:bg-[#0b742f]/5 transition-colors duration-200">
                    <div className="flex-shrink-0 w-8 h-8 bg-[#0b742f] text-white rounded-full flex items-center justify-center font-bold">
                      {index + 1}
                    </div>
                    <p className="text-gray-700 flex-1">{proceso}</p>
                  </div>
                ))}
              </div>

              <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg space-y-3">
                <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <Award className="w-5 h-5 text-[#0b742f]" />
                  Beneficios
                </h3>
                {unitwinData?.beneficios?.map((beneficio, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-1" />
                    <p className="text-gray-700">{beneficio}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Productos del Proyecto */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Sparkles className="w-8 h-8 text-[#e87729]" />
                  Productos del proyecto UNITWIN
                </h2>
                <div className="h-1 w-32 bg-[#0b742f] rounded-full"></div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                {productos.map((producto, index) => {
                  const IconComponent = producto.icono;
                  return (
                    <div key={index} className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                      <div className="flex items-center gap-3 mb-4">
                        <div className={`p-3 rounded-lg ${producto.color === 'blue' ? 'bg-blue-100' : 'bg-green-100'}`}>
                          <IconComponent className={`w-6 h-6 ${producto.color === 'blue' ? 'text-blue-600' : 'text-[#0b742f]'}`} />
                        </div>
                        <h3 className="text-xl font-bold text-gray-900">{producto.titulo}</h3>
                      </div>
                      <p className="text-gray-700">{producto.descripcion}</p>
                    </div>
                  );
                })}
              </div>

              <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg p-6">
                <h3 className="text-xl font-bold mb-3 flex items-center gap-2">
                  <BookOpen className="w-6 h-6" />
                  Revista RICSH
                </h3>
                <p className="text-white/90 mb-2">
                  Los artículos científicos serán publicados en número especial de la <strong>Revista Iberoamericana de las Ciencias Sociales y Humanísticas (RICSH)</strong>
                </p>
                <div className="flex flex-wrap gap-2 mt-4">
                  {['ISBN 2395-7972', 'LATINDEX', 'REDIB', 'DIALNET', 'ERIHPLUS', 'MIAR', 'CLASE', 'LATINREV', 'ROOTINDEXING'].map((index, i) => (
                    <span key={i} className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm">
                      {index}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recepción de Trabajos */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Upload className="w-8 h-8 text-[#0b742f]" />
                  Recepción de trabajos
                </h2>
                <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
              </div>

              <div className="space-y-6">
                <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-2">Plazo de recepción</h3>
                  <p className="text-gray-700">
                    La recepción de los trabajos enviados por las Cátedras Unesco será a partir de la publicación de la presente Convocatoria y hasta{' '}
                    {isLoadingData ? (
                      <Loader2 className="inline w-4 h-4 animate-spin" />
                    ) : (
                      <strong>{unitwinData?.fechasClave?.recepcionTrabajos?.fin || '10 de enero de 2026'}</strong>
                    )}
                    . No se aceptarán trabajos fuera de la fecha estipulada.
                  </p>
                  <div className="mt-3 bg-white/50 p-3 rounded">
                    <p className="text-gray-700">
                      <strong>Importante:</strong> Sin excepción cada trabajo deberá ser elaborado en base a los lineamientos publicación RICSH
                    </p>
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Mail className="w-5 h-5 text-blue-600" />
                    Envío de trabajos
                  </h3>
                  <p className="text-gray-700 mb-2">
                    Las Cátedras UNESCO deberán enviar su trabajo al siguiente correo electrónico:
                  </p>
                  {isLoadingData ? (
                    <div className="flex items-center gap-2">
                      <Loader2 className="w-5 h-5 text-[#0b742f] animate-spin" />
                      <span className="text-gray-600">Cargando...</span>
                    </div>
                  ) : (
                    <a
                      href={`mailto:${unitwinData?.contacto?.email || 'catedraunitwin@cenid.org'}`}
                      className="text-blue-600 font-bold text-lg hover:text-blue-700 flex items-center gap-2 mb-4"
                    >
                      {unitwinData?.contacto?.email || 'catedraunitwin@cenid.org'}
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  )}
                  <p className="text-gray-700">
                    El documento enviado deberá llevar el nombre del archivo del trabajo, nombre de los autores expresando primero nombres y después apellidos (máximo tres autores), la institución de procedencia de las o los autores, ORCID y el objetivo ODS al que se circunscribe.
                  </p>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3">Nomenclatura del archivo</h3>
                  <p className="text-gray-700 mb-2">
                    El archivo se nombrará de la siguiente forma: <strong>apellido_número_ODS</strong>
                  </p>
                  <div className="bg-white/70 p-3 rounded border border-yellow-300">
                    <p className="text-gray-700 font-mono">
                      <strong>Ejemplo:</strong> lopez_4_7
                    </p>
                  </div>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <FileText className="w-5 h-5 text-purple-600" />
                    Proceso de dictaminación
                  </h3>
                  <div className="space-y-3">
                    <p className="text-gray-700">
                      El comité científico dictaminador se reunirá y emitirá sus dictámenes respectivos para divulgación y publicación con <strong>arbitraje doble ciego</strong>, determinando si el trabajo es: aceptado, aceptado con observaciones o rechazado, lo que se notificará a través del correo electrónico que registren en su documento de participación.
                    </p>
                    <p className="text-gray-700">
                      La notificación será enviada a más tardar el{' '}
                      {isLoadingData ? (
                        <Loader2 className="inline w-4 h-4 animate-spin" />
                      ) : (
                        <strong>{unitwinData?.fechasClave?.dictaminacion || '20 de enero de 2026'}</strong>
                      )}
                      , y a partir de la recepción de los primeros trabajos, por parte del comité organizador.
                    </p>
                    <div className="bg-white/70 p-3 rounded border border-purple-300">
                      <p className="text-gray-700">
                        <strong>El dictamen será inapelable.</strong> En caso de ser aceptado con observaciones, se deberá entregar el documento corregido a más tardar <strong>5 días naturales</strong> a partir de que se recibe el dictamen al correo ya indicado, señalando las correcciones -utilizando la herramienta de nuevo comentario inmediatamente después de la corrección en el contenido del trabajo. <strong>Corrección que debe ser escrita en color rojo.</strong>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-white border-2 border-[#0b742f] rounded-lg p-4 hover:shadow-md transition-shadow">
                    <FileText className="w-8 h-8 text-[#0b742f] mx-auto mb-2" />
                    <p className="font-bold text-gray-900 text-center mb-1">Extensión</p>
                    <p className="text-gray-600 text-sm text-center">Mínimo 3,000 palabras</p>
                    <p className="text-gray-600 text-sm text-center">Máximo 6,000 palabras</p>
                  </div>
                  <div className="bg-white border-2 border-[#e87729] rounded-lg p-4 hover:shadow-md transition-shadow">
                    <Users className="w-8 h-8 text-[#e87729] mx-auto mb-2" />
                    <p className="font-bold text-gray-900 text-center mb-1">Autores</p>
                    <p className="text-gray-600 text-sm text-center">Máximo 3 autores</p>
                    <p className="text-gray-600 text-sm text-center">Con ORCID e institución</p>
                  </div>
                  <div className="bg-white border-2 border-blue-500 rounded-lg p-4 hover:shadow-md transition-shadow">
                    <Globe className="w-8 h-8 text-blue-600 mx-auto mb-2" />
                    <p className="font-bold text-gray-900 text-center mb-1">Resumen</p>
                    <p className="text-gray-600 text-sm text-center">Máximo 250 palabras</p>
                    <p className="text-gray-600 text-sm text-center">Origen + inglés</p>
                  </div>
                </div>

                <div className="bg-orange-50 border-l-4 border-[#e87729] p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <BookOpen className="w-5 h-5 text-[#e87729]" />
                    Contenido del resumen
                  </h3>
                  <p className="text-gray-700 mb-3">
                    El resumen no deberá rebasar las 250 palabras, debe exponer de forma sucinta:
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {[
                      'Objetivo',
                      'Elementos de justificación',
                      'Método',
                      'Hallazgos',
                      'Propuesta central',
                      'Beneficios de sostenibilidad',
                      'Igualdad e inclusión',
                      'ODS ligado'
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <CheckCircle className="w-4 h-4 text-[#e87729] flex-shrink-0" />
                        <span className="text-gray-700 text-sm">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Shield className="w-5 h-5 text-red-600" />
                    Originalidad de los trabajos
                  </h3>
                  <p className="text-gray-700 mb-3">
                    La originalidad de los trabajos es responsabilidad de las personas autoras, anexando una carta en la que se manifieste que el trabajo no ha sido presentado y/o publicado en otros eventos y que es de su interés que sea considerado para su publicación.
                  </p>
                  <div className="bg-white/70 p-3 rounded border border-red-300">
                    <p className="text-gray-700">
                      <strong>Nota:</strong> Los trabajos pueden ser cuantitativos, cualitativos, con datos empíricos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Criterios Técnico-Metodológicos */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Shield className="w-8 h-8 text-[#e87729]" />
                  Criterios técnico-metodológicos
                </h2>
                <div className="h-1 w-32 bg-[#0b742f] rounded-full"></div>
              </div>

              <div className="space-y-3">
                {criteriosTecnicos.map((criterio, index) => (
                  <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg hover:bg-[#e87729]/5 transition-colors duration-200">
                    <ArrowRight className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-1" />
                    <p className="text-gray-700">{criterio}</p>
                  </div>
                ))}
              </div>

              <div className="mt-6 bg-orange-50 border-l-4 border-[#e87729] p-6 rounded-r-lg">
                <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                  <FileText className="w-5 h-5 text-[#e87729]" />
                  Contenido del Resumen
                </h3>
                <p className="text-gray-700">
                  El resumen debe exponer de forma sucinta: objetivo, elementos de justificación, método, hallazgos, propuesta central, beneficios de sostenibilidad, igualdad e inclusión, y ODS ligado.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Proceso de Dictaminación */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <CheckCircle className="w-8 h-8 text-[#0b742f]" />
                  Notificación del dictamen
                </h2>
                <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
              </div>

              <div className="space-y-4">
                <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg">
                  <p className="text-gray-700 font-semibold">
                    Sólo se aceptarán trabajos originales que cumplan con los requisitos y lineamientos señalados.
                  </p>
                </div>

                <p className="text-gray-700 leading-relaxed">
                  El comité científico dictaminador se reunirá y emitirá sus dictámenes respectivos para divulgación y publicación con <strong>arbitraje doble ciego</strong>, determinando si el trabajo es: aceptado, aceptado con observaciones o rechazado.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-green-50 border-2 border-green-500 rounded-lg p-4">
                    <CheckCircle className="w-8 h-8 text-green-600 mx-auto mb-2" />
                    <p className="text-center font-bold text-gray-900">Aceptado</p>
                  </div>
                  <div className="bg-yellow-50 border-2 border-yellow-500 rounded-lg p-4">
                    <AlertCircle className="w-8 h-8 text-yellow-600 mx-auto mb-2" />
                    <p className="text-center font-bold text-gray-900">Con observaciones</p>
                  </div>
                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4">
                    <AlertCircle className="w-8 h-8 text-red-600 mx-auto mb-2" />
                    <p className="text-center font-bold text-gray-900">Rechazado</p>
                  </div>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <p className="text-gray-700">
                    La notificación será enviada a más tardar el{' '}
                    {isLoadingData ? (
                      <Loader2 className="inline w-4 h-4 animate-spin" />
                    ) : (
                      <strong>{unitwinData?.fechasClave?.dictaminacion || '20 de enero de 2026'}</strong>
                    )}
                    , al correo electrónico registrado en el documento de participación.
                  </p>
                  <p className="text-gray-700 mt-3">
                    <strong>El dictamen será inapelable.</strong> En caso de ser aceptado con observaciones, se deberá entregar el documento corregido a más tardar <strong>5 días naturales</strong> a partir de que se recibe el dictamen.
                  </p>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Calendar className="w-5 h-5 text-purple-600" />
                    Presentación del trabajo aprobado
                  </h3>
                  <div className="space-y-3">
                    <p className="text-gray-700">
                      Los autores/as del trabajo aprobado deberán presentarse a exponer el día y hora asignados en el programa que se emita al respecto.
                    </p>
                    <p className="text-gray-700">
                      La presentación PowerPoint deberán entregarla con <strong>diez días de anticipación</strong> a la fecha de arranque del evento, es decir el{' '}
                      {isLoadingData ? (
                        <Loader2 className="inline w-4 h-4 animate-spin" />
                      ) : (
                        <strong>{unitwinData?.fechasClave?.entregaPresentacion || '15 de marzo de 2026'}</strong>
                      )}
                      .
                    </p>
                    <p className="text-gray-700">
                      La integración de los trabajos al programa fungirá como documento oficial de aceptación para su publicación. La fecha de publicación del programa será a más tardar el{' '}
                      {isLoadingData ? (
                        <Loader2 className="inline w-4 h-4 animate-spin" />
                      ) : (
                        <strong>{unitwinData?.fechasClave?.programaIntegrado || '28 de enero del 2026'}</strong>
                      )}
                      .
                    </p>
                  </div>
                </div>

                <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Users className="w-5 h-5 text-indigo-600" />
                    Integración de estudiantes
                  </h3>
                  <p className="text-gray-700">
                    Todos los ponentes deberán integrar a sus estudiantes en formación, trátese de licenciatura o posgrado para que participen como espectadores del evento, facilitándoles para tal efecto las direcciones de las redes sociales a través del programa.
                  </p>
                </div>

                <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <Award className="w-5 h-5 text-[#0b742f]" />
                    Constancia de ponente
                  </h3>
                  <p className="text-gray-700">
                    Los autores/as de los trabajos divulgados tendrán derecho a la constancia de ponente.
                  </p>
                </div>

                <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <AlertCircle className="w-5 h-5 text-red-600" />
                    Causales de no aceptación
                  </h3>
                  <ul className="space-y-2">
                    {causalesNoAceptacion.map((causal, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <ArrowRight className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                        <span className="text-gray-700">{causal}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Formato de Ponencia */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#e87729]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Video className="w-8 h-8 text-[#e87729]" />
                  Formato de ponencia del trabajo en el evento
                </h2>
                <div className="h-1 w-32 bg-[#0b742f] rounded-full"></div>
              </div>

              <div className="space-y-4">
                <div className="bg-orange-50 border-l-4 border-[#e87729] p-6 rounded-r-lg">
                  <div className="flex items-center gap-4 mb-3">
                    <Clock className="w-6 h-6 text-[#e87729]" />
                    <p className="text-gray-700 text-lg">
                      Tiempo de exposición: <strong>30 minutos</strong>
                    </p>
                  </div>
                  <p className="text-gray-700">
                    Al finalizar las exposiciones, la persona moderadora dará un espacio de preguntas y comentarios.
                  </p>
                </div>

                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <Download className="w-5 h-5 text-blue-600" />
                    Presentación PowerPoint
                  </h3>
                  <p className="text-gray-700">
                    Las presentaciones deberán prepararse en formato PowerPoint para ser cargadas en el portal de la Cátedra UNESCO Vulnerabilidad e Inclusión Social.
                  </p>
                  <p className="text-gray-700 mt-2">
                    Fecha límite de entrega:{' '}
                    {isLoadingData ? (
                      <Loader2 className="inline w-4 h-4 animate-spin" />
                    ) : (
                      <strong>{unitwinData?.fechasClave?.entregaPresentacion || '15 de marzo de 2026'}</strong>
                    )}
                  </p>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-r-lg">
                  <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                    <Users className="w-5 h-5 text-purple-600" />
                    Participación de estudiantes
                  </h3>
                  <p className="text-gray-700">
                    Todos los ponentes deberán integrar a sus estudiantes en formación, trátese de licenciatura o posgrado para que participen como espectadores del evento.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Fechas Importantes */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Calendar className="w-8 h-8 text-[#0b742f]" />
                  Fechas importantes
                </h2>
                <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
              </div>

              <div className="space-y-4">
                {isLoadingData ? (
                  <div className="flex justify-center items-center py-12">
                    <Loader2 className="w-8 h-8 text-[#0b742f] animate-spin" />
                  </div>
                ) : unitwinData?.fechasImportantes ? (
                  unitwinData.fechasImportantes.map((item, index) => {
                    const IconComponent = getIconComponent(item.icono);
                    return (
                      <div
                        key={index}
                        className={`border-l-4 ${colorClasses[item.color]} p-6 rounded-r-lg hover:shadow-md transition-shadow duration-200`}
                      >
                        <div className="flex items-start gap-4">
                          <div className="flex-shrink-0">
                            <div className="bg-white p-3 rounded-lg shadow-sm">
                              <IconComponent className="w-6 h-6 text-gray-700" />
                            </div>
                          </div>
                          <div className="flex-1">
                            <p className="text-sm text-gray-600 font-semibold mb-1">{item.fecha}</p>
                            <p className="text-lg font-bold text-gray-900">{item.evento}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-gray-600 text-center py-8">No hay fechas disponibles</p>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Constancias 
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-[#0b742f]">
            <div className="p-8">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 flex items-center gap-3 mb-2">
                  <Award className="w-8 h-8 text-[#0b742f]" />
                  Registro y constancias
                </h2>
                <div className="h-1 w-32 bg-[#e87729] rounded-full"></div>
              </div>

              <div className="space-y-6">
                <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg p-6">
                  <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                    <Award className="w-6 h-6" />
                    Entrega de constancias
                  </h3>
                  <p className="text-white/90">
                    Se entregará a cada autor/a registrado por ponencia su constancia, toda vez que se hayan presentado en tiempo y forma en el horario asignado.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                    <div className="flex items-start gap-3 mb-3">
                      <FileText className="w-6 h-6 text-blue-600 flex-shrink-0" />
                      <h3 className="font-bold text-gray-900">Registro de nombres</h3>
                    </div>
                    <p className="text-gray-700">
                      El registro de los nombres en las constancias será con apego a los nombres escritos en los trabajos. Por lo que se deberá tener cuidado en su correcta escritura.
                    </p>
                  </div>

                  <div className="bg-green-50 border-l-4 border-[#0b742f] p-6 rounded-r-lg">
                    <div className="flex items-start gap-3 mb-3">
                      <Mail className="w-6 h-6 text-[#0b742f] flex-shrink-0" />
                      <h3 className="font-bold text-gray-900">Envío de constancias</h3>
                    </div>
                    <p className="text-gray-700">
                      Las constancias serán enviadas a los correos registrados en los trabajos.
                    </p>
                  </div>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
                  <div className="flex items-start gap-3">
                    <AlertCircle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-gray-900 mb-2">Situaciones no previstas</h3>
                      <p className="text-gray-700">
                        Las situaciones no previstas en la presente convocatoria serán resueltas por el comité evaluador.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        */}

        {/* Llamada a la Acción Final
        <section>
          <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
            <Globe className="w-16 h-16 mx-auto mb-6" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              ¿Listo para participar?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
              Únete al Segundo Encuentro Iberoamericano de Cátedras UNESCO y comparte tu investigación sobre los Objetivos de Desarrollo Sostenible.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              {isLoadingData ? (
                <div className="flex items-center gap-2 bg-white text-[#0b742f] px-8 py-4 rounded-lg">
                  <Loader2 className="w-5 h-5 animate-spin" />
                  <span className="font-bold">Cargando...</span>
                </div>
              ) : (
                <a
                  href={`mailto:${unitwinData?.contacto?.email || 'catedraunitwin@cenid.org'}`}
                  className="bg-white text-[#0b742f] px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors duration-200 flex items-center gap-2"
                >
                  <Send className="w-5 h-5" />
                  Enviar trabajo
                </a>
              )}
              <button className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-colors duration-200 flex items-center gap-2">
                <Download className="w-5 h-5" />
                Descargar convocatoria
              </button>
            </div>
            <p className="mt-6 text-white/80">
              <strong>Sede remota:</strong> CENID en coordinación con la UAEMéx
            </p>
          </div>
        </section>
        */}

      </div>
    </div>
  );
};

export default ProyectoUNITWIN;
